module.exports = __webpack_public_path__ + "static/assets/37ca9e8d78728a5d63dcbe97dcc4e5f2.png";